var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83469 16.6583C8.42675 18.9606 10.5149 20.6619 13 20.6619C15.4851 20.6619 17.5732 18.9606 18.1653 16.6583M11.6903 1.66347L2.64719 8.70329C2.04269 9.17388 1.74045 9.40918 1.52271 9.70384C1.32983 9.96485 1.18613 10.2589 1.09871 10.5715C1 10.9245 1 11.3077 1 12.0743V21.7295C1 23.2243 1 23.9716 1.29065 24.5427C1.54631 25.0449 1.95425 25.4532 2.45603 25.7091C3.02645 26 3.77319 26 5.26667 26H20.7333C22.2268 26 22.9736 26 23.544 25.7091C24.0457 25.4532 24.4537 25.0449 24.7093 24.5427C25 23.9716 25 23.2243 25 21.7295V12.0743C25 11.3077 25 10.9245 24.9013 10.5715C24.8139 10.2589 24.6701 9.96485 24.4773 9.70384C24.2596 9.40918 23.9573 9.17388 23.3528 8.7033L14.3097 1.66347C13.8413 1.29881 13.6071 1.11647 13.3484 1.04638C13.1203 0.984539 12.8797 0.984539 12.6516 1.04638C12.3929 1.11647 12.1587 1.29881 11.6903 1.66347Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.d7439681d4fa0213e00e2a683f0bf0f8.svg";
export { ForwardRef as ReactComponent };